import type { Filter } from '@spendesk/bookkeeping-core-types';
import * as NEA from '@spendesk/general-type-helpers/NonEmptyArray';
import { useMemo } from 'react';

import { useEnrichedPayablesQuery } from 'modules/bookkeep/apis/prepare-payable/useEnrichedPayablesQuery/useEnrichedPayablesQuery';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

// TODO: rewrite to specific endpoint once it will be implemented
/**
 * Hook to get the accounting date of the first exported Spanish DPR payable
 * sorted by accounting date ascending.
 * This is used to determine the start date for Spanish DPR archiving.
 */
export const useSpanishDprStartDateQuery = () => {
  const filters: Filter = useMemo(
    () => ({
      operator: 'and',
      subfilters: [
        {
          field: 'documentaryEvidenceStatus',
          operator: '=',
          value: NEA.fromSingleItem('providedAndDpr'),
        },
        {
          field: 'bookkeepingStatus',
          operator: '=',
          value: NEA.fromSingleItem('exported'),
        },
      ],
    }),
    [],
  );

  const query = useEnrichedPayablesQuery(filters, '', 'date-asc', 1);
  const result = unwrapQuery(query);

  return result?.pages[0]?.payables[0]?.accountingDate;
};
